export abstract class DomainEvent {
  readonly timestamp: number = Date.now()
  abstract readonly type: string
}
